import React from "react";
import ModalInDrawer from "../ui/ModalInDrawer";

const EditarPrecioServicioCotizacion = ({
  open,
  onClose,
  price,
  setPrice,
}) => {
  return (
    <ModalInDrawer
      activeModal={open}
      onClose={onClose}
      centered
      title="Editar precio de servicio"
    >
      <div className="w-full mb-4 border border-gray-200 rounded-lg bg-gray-50  ">
        <div className="px-4 py-2 bg-white rounded-t-lg ">
          <label htmlFor="comment" className="sr-only">
            Tu precio personalizado
          </label>
          <input
            id="comment"
            rows="8"
            type="number"
            value={price}
            onChange={(e)=>setPrice(Number(e.target.value))}
            className="w-full px-0 text-xs text-gray-900 bg-white border-0  focus:ring-0 "
           
            required
          />
        </div>
        <div className="flex items-center justify-center px-3 py-2 border-t ">
          <button
            type="button"
            onClick={()=>onClose()}
            className="inline-flex items-center  text-center py-2.5 px-4 text-xs font-medium  text-white bg-blue-700 rounded-lg focus:ring-4 focus:ring-blue-200  hover:bg-blue-800"
          >
            Guardar
          </button>
        </div>
      </div>
    </ModalInDrawer>
  );
};

export default EditarPrecioServicioCotizacion;
